import PeopleSearchCombobox from './PeopleSearchCombobox';

export { type PeopleSearchComboboxProps } from './PeopleSearchCombobox';
export default PeopleSearchCombobox;
